import React from 'react';
import './Logo.css';

const Logo = ({ className = '', size = 'medium' }) => {
  return (
    <div className={`company-logo ${size} ${className}`}>
      <div className="logo-icon">
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          {/* Bridge symbol representing connection between Europe and Asia */}
          <path
            d="M4 28 C4 28, 12 16, 24 16 C36 16, 44 28, 44 28"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            fill="none"
          />
          <path
            d="M4 28 L4 32 M44 28 L44 32"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
          {/* Pillars */}
          <path
            d="M12 20 L12 32 M24 16 L24 32 M36 20 L36 32"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          {/* Base */}
          <path
            d="M2 32 L46 32"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="logo-text">
        <span className="logo-company">Bridgepoint</span>
        <span className="logo-tagline">Policy Group</span>
      </div>
    </div>
  );
};

export default Logo;
